<template>
  <div>
    <div v-if="targetBookGroups && targetTickets">
      <!-- ヘッダー -->
      <MTKHeader />

      <!-- BookGroupCardのループと、それの確定ボタン -->
      <TheBgRadioForm
        :targetBookGroups="targetBookGroups"
        :targetTickets="targetTickets"
      />
    </div>

    <!-- 初期ローディング -->
    <DialogLoading ref="DialogLoading" />

    <!-- 失敗ダイアログ -->
    <DialogQRFail ref="QRFail" failTitle="読み込みがうまくいきませんでした" />
  </div>
</template>

<script>
import MTKMixin from "@/mixins/SetQR/MTKMixin";

import API from "@/API";

export default {
  name: "TemplateMTK",
  mixins: [MTKMixin],
  data() {
    return {
      targetBookGroups: null,
      targetTickets: null,
    };
  },
  methods: {
    // MTK
    async MTK() {
      // ローディングダイアログ表示
      this.$refs.DialogLoading.openDialog();

      try {
        // 該当MasterBook取得
        await API.getMasterBook(this.$route.query.master_book_id);
      } catch (err) {
        // DBにないIDの場合は処理中止でダイアログ表示
        this.$refs.QRFail.openDialog();
        return false;
      }

      // 読み込んだQR文字列に対応したBookGroupを整理する
      var Return = await this.arrangeBookGroup();

      if (Return) {
        // それらをdataへ代入
        this.targetBookGroups = Return.targetBookGroups;
        this.targetTickets = Return.targetTickets;

        // ローディングダイアログを閉じる
        // arrangeBookGroup内で別ページに映ってしまいundefindになりうるのでif文で囲む
        if (this.$refs.DialogLoading) {
          this.$refs.DialogLoading.closeDialog();
        }
      }
    },
  },
};
</script>
